import { useState } from "react"
import { Link } from "@inertiajs/react"
import { Button } from "@/components/ui/Button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/Card"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/Table"
import { type Plan, longDate, productById, units } from "../data"

const SHOWN_FIRST = 5

// One plan, readable without opening it: by-date, then the products with
// supplier, quantity and minimum order.
export default function PlanCard({ plan }: { plan: Plan }) {
  const [showAll, setShowAll] = useState(false)
  const shown = showAll ? plan.products : plan.products.slice(0, SHOWN_FIRST)
  const hidden = plan.products.length - SHOWN_FIRST
  const total = plan.products.reduce((sum, p) => sum + p.quantity, 0)

  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between gap-4">
        <div>
          <CardTitle>{plan.name}</CardTitle>
          <div className="mt-1 text-sm">
            By {longDate(plan.byDate)} · {plan.products.length} products · {units(total)} units
          </div>
        </div>
        <Button asChild variant="outline" size="sm">
          <Link href={`/wireframes/purchase/plans/${plan.id}`}>Open plan</Link>
        </Button>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Product</TableHead>
              <TableHead>Supplier</TableHead>
              <TableHead className="text-right">Quantity</TableHead>
              <TableHead className="text-right">Minimum order</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {shown.map((planProduct) => (
              <TableRow key={planProduct.productId}>
                <TableCell>{productById(planProduct.productId).name}</TableCell>
                <TableCell>{planProduct.supplier || "No supplier yet"}</TableCell>
                <TableCell className="text-right tabular-nums">{units(planProduct.quantity)}</TableCell>
                <TableCell className="text-right tabular-nums">
                  {planProduct.moq === null ? "" : units(planProduct.moq)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {hidden > 0 && (
          <Button variant="link" size="sm" className="mt-2 px-0" onClick={() => setShowAll(!showAll)}>
            {showAll ? "Show less" : `Show ${hidden} more`}
          </Button>
        )}
      </CardContent>
    </Card>
  )
}
